import React from 'react';
import clsx from 'clsx';

import { ButtonColor, ButtonStyle } from 'components/Button/constants';
import { FontSize } from 'components/Card/constants';
import { isAdmin } from 'modules/admin';
import { ReactComponent as ErrorSVG } from 'modules/theme/images/icons/inputs/error.svg';
import { UsePolicyTrip } from 'modules/redux/states/policy/hooks/usePolicySummary';
import Button from 'components/Button';
import Card from 'components/Card';

import styles from './styles.module.scss';

type TripErrorProps = {
  handleError: UsePolicyTrip['handleError'];
  isError: UsePolicyTrip['isError'];
};

const ErrorMessage: React.FunctionComponent<TripErrorProps> = ({
  handleError,
  isError,
}) => {
  const classNames = clsx(styles['events-summary-error']);
  return (
    <Card className={classNames} fontSize={FontSize.SMALL} title="Trip">
      <ErrorSVG />
      <h2>{isAdmin ? 'Error' : 'Something went wrong'}</h2>
      {isAdmin && !!isError && isError.message && <p>{isError.message}</p>}
      <Button
        color={ButtonColor.BLUE}
        label="Retry"
        onClick={handleError}
        style={ButtonStyle.PRIMARY}
      />
    </Card>
  );
};

export default React.memo(ErrorMessage);
